import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "api/callApi";
import { Button, DetailDrawer, Loader } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import RoleSelection from "./RoleSelection";
import theme from "theme";
import SC from "./style";
import UserProjectDropdown from "components/UserProjectDropDown";
import { ProjectDropdown } from "@components/";
import AssignUser from "views/AdminSettings/Projects/AssignUser";
import { showAlert } from "utils/helper/index.js";

function AssignRoles(props) {
  const {
    onClose = () => {},
    userdata,
    fetchData = () => {},
    defaultProject = null,
    setOpenAssignRoleDrawer,
    setCurrentPage = () => {},
    addressBook = false,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [userProjectId, setUserProjectId] = useState(defaultProject);
  const [currentProject, setCurrentProject] = useState();
  const [userProjectDropdownData, setUserProjectDropdownData] = useState([]);

  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    onClose();
    setTimeout(() => {
      setOpenAssignRoleDrawer(true);
    }, 500);
  };

  const handleProjectChange = (selectedProject) => {
    setUserProjectId(selectedProject);
  };

  const getUserAssignRole = async (projectId) => {
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/${userdata.id}/roles/${projectId}`,
        false,
      );

      const assignedRoles = response.data.map((role) => role.roleId);
      setSelectedItems(assignedRoles);

      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserAssignRole(userProjectId);
  }, [userProjectId]);

  const manageAssignUserRole = async () => {
    if (!userProjectId) {
      showAlert({
        title: "Please select a project",
        text: "You need to choose a project first",
        icon: "warning",
      });

      return;
    }

    try {
      setLoading(true);
      const response = await apiPost(
        `/v1/users/${userdata.id}/roles/${userProjectId}`,
        { roles: selectedItems },
      );
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setLoading(false);
      onClose();
      await fetchData();
      if (setCurrentPage) {
        setCurrentPage(1);
      }
    } catch (error) {
      console.log("error", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
      setLoading(false);
    }
  };

  const getRole = async () => {
    try {
      setLoading(true);
      const response = await apiGet("/v1/roles?active=true", false);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getRole();
  }, []);

  const onSelectionChange = (id, selectAll = false) => {
    if (!userProjectId) {
      showAlert({
        title: "Please select a project",
        text: "You need to choose a project first",
        icon: "warning",
      });

      return;
    }

    if (id === "clear") {
      setSelectedItems([]);
      return;
    }

    const availableRoleIds = data.map((item) => item.id);

    setSelectedItems((prevSelectedItems) => {
      if (selectAll) {
        return availableRoleIds;
      }

      const isValidRole = availableRoleIds.includes(id);
      if (!isValidRole) {
        console.warn("Invalid Role ID:", id);
        return prevSelectedItems;
      }

      const updatedSelectedItems = prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((item) => item !== id)
        : [...prevSelectedItems, id];

      return updatedSelectedItems.filter((item) =>
        availableRoleIds.includes(item),
      );
    });
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          Assign Roles to {userdata?.fullName || "user"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {loading && <Loader />}

      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
        }}
      >
        <UserProjectDropdown
          onChange={handleProjectChange}
          userId={userdata?.id}
          setUserProjectDropdownData={setUserProjectDropdownData}
          defaultValue={userProjectId}
          disabledDropdown={addressBook}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                background: "#f7f9f7",
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={onClose}
            />
            <Button
              caption={"Save"}
              type="submit"
              isLoading={loading}
              onClick={manageAssignUserRole}
              color="white"
              fontSize="12px"
              style={{
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={data.length == 0}
            />
          </SC.ButtonContainer>

          {!addressBook && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                caption="Manage Project Assignment"
                fontSize="12px"
                color="white"
                style={{
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
                onClick={() => setopenAssignUserDrawer(true)}
              />
            </div>
          )}
        </div>
      </div>
      <div style={{ padding: "0px 20px" }}>
        <RoleSelection
          items={data}
          title="Role"
          onSelectionChange={onSelectionChange}
          selectedItems={selectedItems}
          userProjectId={userProjectId}
        />
      </div>

      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              onClose={closeAssignUserDrawer}
              project={""}
              closeOnSave={true}
              // fetchData={getAlldata}
            />
          }
        />
      )}
    </>
  );
}

export default AssignRoles;
